import CountryProduct from "../../addons/src/country_product";
import FormFilter from "../../addons/src/form_filter.js";
import SkeletonLoader from "../../addons/src/skeleton_loader.js";
import ProductsLoader from "../../addons/src/products_loader.js";
import {CatalogContext} from "../../addons/src/catalog_context";
import Fade from "../fade";
const noResultsText = gettext("No results found");
const noResultsSubText = gettext("Try changing your search term and then filtering the results.");
class CountryProducts extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addons: [],
            page_number: 1,
            page_limit: 20,
            page_offset: 0,
            isLoadingFilters: false,
            isLoading: false,
            isLoadingMore: false,
            isLoadingCart: false,
            estimatedTotalHits: 0,
            filter_data:{
                continents: [],
                countries_iso: [],
                editor: [],
                scale: []
            },
            meilisearch_search: "",
            meilisearch_filter_tags: [],
            meilisearch_countryiso_filter: [],
            meilisearch_country_filter: [],
            meilisearch_editor_filter: [],
            meilisearch_scale_filter: [],
            type_timer: null,
            catalog_data: {},
        };
        this.searchProduct = this.searchProduct.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.renderFilters = this.renderFilters.bind(this);
        this.handleAllFilter = this.handleAllFilter.bind(this);
        this.removeAllFilters = this.removeAllFilters.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.handlePaginate = this.handlePaginate.bind(this);
        this.storeRedirectCart = this.storeRedirectCart.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevState.meilisearch_countryiso_filter.length !== this.state.meilisearch_countryiso_filter.length ||
            prevState.meilisearch_country_filter.length !== this.state.meilisearch_country_filter.length ||
            prevState.meilisearch_editor_filter.length !== this.state.meilisearch_editor_filter.length ||
            prevState.meilisearch_scale_filter.length !== this.state.meilisearch_scale_filter.length ||
            prevState.meilisearch_search !== this.state.meilisearch_search){
            clearTimeout(this.state.type_timer);
            const newTimer = setTimeout(() => {
                this.updateMeilisearch();
            }, 1000);

            this.setState({
                type_timer: newTimer
            });
        }

        if(prevState.page_number !== this.state.page_number && this.state.page_number !== 1){
            const newTimer = setTimeout(() => {
                this.updateProductList();
            }, 100);

            this.setState({
                type_timer: newTimer
            });
        }
    }

    componentDidMount() {
        // On the first render the api must be called first before the user data is requested again
        // this is to get the filters from meilisearch
        this.getProducts();
        this.renderFilters();
        let tempObj = Object.assign({}, catalogModule.catalogData)
        this.setState({
            catalog_data: tempObj
        });
        // setTimeout(() => {
        //     this.setState({
        //         isLoading: false
        //     });
        // }, 500);
    }


    componentWillUnmount() {
        if(this.state.type_timer){
            clearTimeout(this.state.type_timer);
        }
    }

    async getProducts(){
        let selectedRegion = catalogModule.getSelectedReg();
        let filtersArr = [];
        if(meilisearch_default_filter){
            filtersArr.push(meilisearch_default_filter);
        }
        if(selectedRegion){
            filtersArr.push([`continents='${selectedRegion}'`]);
        }
        this.setState({
            isLoading: true
        });
        let results = await catalogModule.getMeiliProducts({
            search: "",
            filters: filtersArr,
            sort: ["featured:asc"]
        });
        if(results.hasOwnProperty("hits") && results.hits.length > 0){
            // let sortedProducts = sort_country_products(results.hits);
            let sortedProducts = results.hits;

            this.setState({
                meilisearch_country_filter: [`continents='${selectedRegion}'`],
                addons: sortedProducts,
                estimatedTotalHits: results.estimatedTotalHits
            });
        }
    }

    handleAllFilter(filter, checkState){
        let tempArr = [];
        let tempArrFilter = Object.assign({}, this.state.filter_data);
        let key;

        tempArrFilter[filter].map((data) => {
            if(filter === "continents"){
                if(data.key !== "South East Europe" && data.key !== "Southern Indian Ocean") {
                    if(!checkState){
                        tempArr.push(`${filter}='${data.key}'`);
                    }
                    data.checkState = !checkState;
                }
            } else {
                if(!checkState){
                    tempArr.push(`${filter}='${data.key}'`);
                }
                data.checkState = !checkState;
            }
        });


        if(filter === "continents"){
            key = "meilisearch_country_filter";
        }
        if(filter === "countries_iso"){
            key = "meilisearch_countryiso_filter";
        }
        if(filter === "scale"){
            key = "meilisearch_scale_filter";
        }
        if(filter === "editor"){
            key = "meilisearch_editor_filter";
        }
        this.setState({
            [key]: tempArr,
            filter_data: tempArrFilter
        });
    }

    handlePaginate(){
        let pageNum = this.state.page_number;
        let addedPageNum = pageNum + 1;
        this.setState({
            page_number: addedPageNum,
            page_offset: this.state.page_limit * (addedPageNum - 1)
        });
    }

    handleFilter(dom, filter, value){
        let tempArr;
        let tempArrTags = [];
        let key;
        let tempArrFilter = Object.assign({}, this.state.filter_data);
        switch(filter){
            case 'continents':
                tempArr = [...this.state.meilisearch_country_filter];
                key = "meilisearch_country_filter";
                break;
            case 'countries_iso':
                tempArr = [...this.state.meilisearch_countryiso_filter];
                key = "meilisearch_countryiso_filter";
                break;
            case 'editor':
                tempArr = [...this.state.meilisearch_editor_filter];
                key = "meilisearch_editor_filter";
                break;
            case 'scale':
                tempArr = [...this.state.meilisearch_scale_filter];
                key = "meilisearch_scale_filter";
                break;
            default:
                break;
        }
        tempArrFilter[filter].find((data) => {
            if(data.key === value){
                data.checkState = !data.checkState;
            }
        });
        if(dom.target.checked){
            tempArr.push(`${filter}='${value}'`);
            tempArrTags.push(value);
        } else {
            tempArr = this.removeFilter(tempArr, `${value}`);
        }
        this.setState({
            [key]: tempArr,
            filter_data: tempArrFilter,
            meilisearch_filter_tags: tempArrTags
        });
    }

    removeAllFilters(filter, checkState){
        let tempArr = [];
        let tempArrFilter = Object.assign({}, this.state.filter_data);
        let key;

        tempArrFilter[filter].map((data) => {
            if(filter === "continents"){
                if(data.key !== "South East Europe" && data.key !== "Southern Indian Ocean") {
                    data.checkState = false;
                }
            } else {
                data.checkState = false;
            }
        });

        if(filter === "continents"){
            key = "meilisearch_country_filter"
        }
        if(filter === "countries_iso"){
            key = "meilisearch_countryiso_filter"
        }
        if(filter === "editor"){
            key = "meilisearch_editor_filter"
        }
        if(filter === "scale"){
            key = "meilisearch_scale_filter"
        }
        this.setState({
            [key]: tempArr,
            filter_data: tempArrFilter,
            meilisearch_filter_tags: []
        });
    }

    removeFilter(list, regexPattern) {
        let regex = new RegExp(regexPattern);
        return list.filter(item => !regex.test(item));
    }

    async updateProductList(){
        let pageNum = this.state.page_number;
        let tempAddonsList = [...this.state.addons];
        let searchFilter2 = [];
        let tempSearch = this.state.meilisearch_search;
        let tempCountryIso = [...this.state.meilisearch_countryiso_filter];
        let tempCountry = [...this.state.meilisearch_country_filter];
        let tempEditor = [...this.state.meilisearch_editor_filter];
        let tempScale = [...this.state.meilisearch_scale_filter];
        let tempFilterData = Object.assign({}, this.state.filter_data);
        searchFilter2.push(`${meilisearch_default_filter}`);
        if(tempCountryIso.length > 0){
            searchFilter2.push(tempCountryIso);
        }
        if(tempCountry.length > 0){
            searchFilter2.push(tempCountry);
        }
        if(tempEditor.length > 0){
            searchFilter2.push(tempEditor);
        }
        if(tempScale.length > 0){
            searchFilter2.push(tempScale);
        }
        let tempFilterObj = {
            search: tempSearch,
            filters:  searchFilter2,
            offset: this.state.page_offset,
            sort: ["featured:asc"]
        }
        this.setState({
            isLoadingMore: true
        });
        let results = await catalogModule.getMeiliProducts(tempFilterObj);
        this.setState({
            addons: tempAddonsList.concat(results.hits),
            isLoadingMore: false,
        });
    }

    async updateMeilisearch(){
        // let tempResp = [];
        // let meilisearch_filter = []
        // let searchFilter = meilisearch_default_filter + " AND countries_iso = " + country_iso_code_global;
        let searchFilter = [];
        let tempSearch = this.state.meilisearch_search;
        let tempCountryIso = [...this.state.meilisearch_countryiso_filter];
        let tempCountry = [...this.state.meilisearch_country_filter];
        let tempEditor = [...this.state.meilisearch_editor_filter];
        let tempScale = [...this.state.meilisearch_scale_filter];
        let tempFilterData = Object.assign({}, this.state.filter_data);
        searchFilter.push(`${meilisearch_default_filter}`);
        if(tempCountryIso.length > 0){
            searchFilter.push(tempCountryIso);
        }
        if(tempCountry.length > 0){
            searchFilter.push(tempCountry);
        }
        if(tempEditor.length > 0){
            searchFilter.push(tempEditor);
        }
        if(tempScale.length > 0){
            searchFilter.push(tempScale);
        }
        let tempFilterObj = {
            search: tempSearch,
            filters:  searchFilter,
            sort: ["featured:asc"]
        }
        if(!this.state.isLoading){
            this.setState({
                isLoading: true
            });
        }
        let results = await catalogModule.getMeiliProducts(tempFilterObj);
        let tempArrContinents = [];
        let tempArrCountries = [];
        let tempArrEditors = [];
        let tempArrScales = [];
        if(results){
            if(results.hasOwnProperty("facetDistribution") && Object.keys(results.facetDistribution).length > 0){
                Object.keys(results.facetDistribution).map((key_filter) => {
                    Object.keys(results.facetDistribution[key_filter]).map((data, index) => {
                        let isSelected = tempFilterData[key_filter].find((data_filter) => data_filter.key === data);
                        if(key_filter === "continents"){
                            let regionName = baseBindData.getRegion(data);
                            if(!isSelected){
                                if(tempCountry.length > 0){
                                    let tempcheckState = tempCountry.find((region_filter) => region_filter.indexOf(data) > 0);
                                    isSelected = {
                                        key: data,
                                        name: regionName,
                                        number: results.facetDistribution[key_filter][data],
                                        indexForm: index,
                                        checkState: tempcheckState
                                    }
                                }
                            }
                            tempArrContinents.push({
                                key: data,
                                name: regionName,
                                number: results.facetDistribution[key_filter][data],
                                indexForm: index,
                                checkState: isSelected ? isSelected.checkState : false
                            });
                        } else if(key_filter === "countries_iso"){
                            let isoName = baseBindData.getCountry(data);
                            if(!isSelected){
                                if(tempCountryIso.length > 0){
                                    let tempcheckState = tempCountryIso.find((iso_filter) => iso_filter.indexOf(data) > 0);
                                    isSelected = {
                                        key: data,
                                        name: isoName,
                                        number: results.facetDistribution[key_filter][data],
                                        indexForm: index,
                                        checkState: tempcheckState
                                    }
                                }
                            }
                            tempArrCountries.push({
                                key: data,
                                name: isoName,
                                number: results.facetDistribution[key_filter][data],
                                indexForm: index,
                                checkState: isSelected ? isSelected.checkState : false
                            });
                        } else if(key_filter === "editor"){
                            if(!isSelected){
                                if(tempEditor.length > 0){
                                    let tempcheckState = tempEditor.find((editor_filter) => editor_filter.indexOf(data) > 0);
                                    isSelected = {
                                        key: data,
                                        name: data,
                                        number: results.facetDistribution[key_filter][data],
                                        indexForm: index,
                                        checkState: tempcheckState
                                    }
                                }
                            }
                            tempArrEditors.push({
                                key: data,
                                name: data,
                                number: results.facetDistribution[key_filter][data],
                                indexForm: index,
                                checkState: isSelected ? isSelected.checkState : false
                            });
                        } else if(key_filter === "scale"){
                            if(!isSelected){
                                if(tempScale.length > 0){
                                    let tempcheckState = tempScale.find((scale_filter) => scale_filter.indexOf(data) > 0);
                                    isSelected = {
                                        key: data,
                                        name: data,
                                        number: results.facetDistribution[key_filter][data],
                                        indexForm: index,
                                        checkState: tempcheckState
                                    }
                                }
                            }
                            tempArrScales.push({
                                key: data,
                                name: data,
                                number: results.facetDistribution[key_filter][data],
                                indexForm: index,
                                checkState: isSelected ? isSelected.checkState : false
                            });
                        }
                    })
                });
            }
            if(this.state.catalog_data.hasOwnProperty("products_hidden_but_sold")){
                results.hits.map((product) => {
                    if(this.state.catalog_data.products_hidden_but_sold.includes(product.key)){
                        product["state"] = "selling";
                        product["included_in_pkg"] = "not_included";
                    }
                });
            }
            
        }
        let tempObj = {
            continents: tempArrContinents,
            countries_iso: tempArrCountries,
            editor: tempArrEditors,
            scale: tempArrScales
        };
        this.setState({
            estimatedTotalHits: results.estimatedTotalHits,
            page_number: 1,
            page_offset: 0,
            addons: results.hits,
            isLoading: false,
            filter_data: tempObj
        });
    }

    async searchProduct(e){
        this.setState({
            meilisearch_search: e.target.value
        });
    }

    async renderFilters(){
        this.setState({
            isLoadingFilters: true
        });
        let tempArrContinents = [];
        let tempArrCountries = [];
        let tempArrEditors = [];
        let tempArrScales = [];
        let selectedRegion = catalogModule.getSelectedReg();
        let results = await catalogModule.getMeiliFilters({
            filters: [meilisearch_default_filter, [`continents='${selectedRegion}'`]]
        });
        if(results){
            if(results.hasOwnProperty("continents") && Object.keys(results.continents).length > 0){
                Object.keys(results.continents).map((region, index) => {
                    let regionName = baseBindData.getRegion(region);
                    tempArrContinents.push({
                        key: region,
                        name: regionName,
                        number: results.continents[region],
                        indexForm: index,
                        checkState: selectedRegion === region // Set user default region
                    });
                });
            }
            if(results.hasOwnProperty("countries_iso")){
                Object.keys(results.countries_iso).map((iso, index) => {
                    let regionName = baseBindData.getCountry(iso);
                    tempArrCountries.push({
                        key: iso,
                        name: regionName,
                        number: results.countries_iso[iso],
                        indexForm: index,
                        checkState: false
                    })
                });
            }
            if(results.hasOwnProperty("editor")){
                Object.keys(results.editor).map((editor, index) => {
                    tempArrEditors.push({
                        key: editor,
                        name: editor,
                        number: results.editor[editor],
                        indexForm: index,
                        checkState: false
                    })
                });
            }
            if(results.hasOwnProperty("scale")){
                Object.keys(results.scale).map((scale, index) => {
                    tempArrScales.push({
                        key: scale,
                        name: scale,
                        number: results.scale[scale],
                        indexForm: index,
                        checkState: false
                    })
                });
            }
            let tempObj = {
                continents: tempArrContinents,
                countries_iso: tempArrCountries,
                editor: tempArrEditors,
                scale: tempArrScales
            };

            this.setState({
                isLoadingFilters: false,
                filter_data: tempObj
            });
        }
    }

    storeRedirectCart(){
        this.setState({
            isLoadingMore: true
        });
        if(this.props.onRedirectPage){
            this.props.onRedirectPage();
        }
    }

    render() {
        const pStyle = {
            // color: "#9a9a9a",
            fontSize: '14px',
            paddingBottom: '10px',
            margin: '0 auto'
        };
        const pWarningStyle = {
            color: "red",
            fontSize: '11px',
            fontWeight: 'bold',
            margin: '0 auto'
        };
        const hideStyle = {
            display: 'block'
        };
        let textWarning = gettext("You can only own one package at a time. Acquiring a package replaces any one you own, even across countries.");
        let renderMessage = <h2 className="col-md-12 text-center">{gettext("Or get Products individually")}</h2>;
        const loadMoreText = gettext("Load More");
        // <h2 className="col-md-12 text-center">{gettext("The following products are available")}</h2>
        const { catalog_data, isLoading, isLoadingMore, meilisearch_search } = this.state;
        const { page, storeSkipText, storeNextText, storeBtnTopText, onAddToCart, onRemoveToCart, cart_list } = this.props;
        const { app_theme, products_hidden_but_sold } = catalog_data;
        const { continents, countries_iso, scale, editor } = this.state.filter_data;

        let renderWarningMessage = catalog_data.has_package && catalog_data.has_package_other ? <p className="text-center" style={pWarningStyle}>{textWarning}</p> : null;

        let renderAddons = this.state.addons.length > 0 ? this.state.addons.map((data, index) => {
            if(data.state !== "hidden" || products_hidden_but_sold.includes(data.key)){
                return <CountryProduct product={data} key={index}
                                       page={page}
                                       onAddToCart={onAddToCart}
                                       onRemoveToCart={onRemoveToCart} />
            }
        }) : null;

        // let renderFilterTags = this.state.meilisearch_filter_tags ? this.state.meilisearch_filter_tags.map((data, index) => {
        //     return <li key={index}>{data}<a href="">x</a></li>
        // }) : null
        return (
            <React.Fragment>
                <CatalogContext.Provider value={this.state}>
                    { app_theme && app_theme === 'services' && renderWarningMessage }
                    { app_theme && app_theme === 'services' && <hr className="my-6"/> }
                    { app_theme && app_theme === 'services' && renderMessage }
                    { app_theme && app_theme === 'services' && <p className="text-center" style={pStyle}>{gettext("Explore the catalog below and choose the products that fit your flights needs.")}</p> }
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-group my-4">
                            <span className="input-group-text">
                                <i className="bi bi-search form-control-feedback"></i>
                            </span>
                                <input type="text" id="search_product" className="form-control" placeholder="Search" onChange={this.searchProduct} style={hideStyle} />
                            </div>
                            <div className="form-group has-feedback has-search m-4">
                                {/*<i className='fa fa-search form-control-feedback' aria-hidden='true'></i>*/}
                            </div>
                        </div>
                        {/*<div className="col-md-12">*/}
                        {/*    <div className="filter-list">*/}
                        {/*        <ul className="filter-list-tag">*/}
                        {/*            {renderFilterTags}*/}
                        {/*        </ul>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<FormFilters isLoadingFilters={this.state.isLoadingFilters} />*/}
                        <div className="col-md-3">
                            { this.state.isLoadingFilters && <SkeletonLoader width={'100%'} height={'25px'}/>}
                            { !this.state.isLoadingFilters && <FormFilter name={"continents"}
                                                                          onHandleFilter={this.handleFilter}
                                                                          onHandleAllFilter={this.handleAllFilter}
                                                                          onHandleRemoveAllFilter={this.removeAllFilters}
                                                                          text={"Region"}
                                                                          data={continents}
                                                                          meilisearch_search={meilisearch_search} />}
                        </div>
                        <div className="col-md-3">
                            { this.state.isLoadingFilters && <SkeletonLoader width={'100%'} height={'25px'}/>}
                            { !this.state.isLoadingFilters && <FormFilter name={"countries_iso"}
                                                                          onHandleFilter={this.handleFilter}
                                                                          onHandleAllFilter={this.handleAllFilter}
                                                                          onHandleRemoveAllFilter={this.removeAllFilters}
                                                                          text={"Country"}
                                                                          data={countries_iso}
                                                                          meilisearch_search={meilisearch_search} />}
                        </div>
                        <div className="col-md-3">
                            { this.state.isLoadingFilters && <SkeletonLoader width={'100%'} height={'25px'}/>}
                            { !this.state.isLoadingFilters && <FormFilter name={"scale"}
                                                                          onHandleFilter={this.handleFilter}
                                                                          onHandleAllFilter={this.handleAllFilter}
                                                                          onHandleRemoveAllFilter={this.removeAllFilters}
                                                                          text={"Scale"}
                                                                          data={scale}
                                                                          meilisearch_search={meilisearch_search} />}
                        </div>
                        <div className="col-md-3">
                            { this.state.isLoadingFilters && <SkeletonLoader width={'100%'} height={'25px'}/>}
                            { !this.state.isLoadingFilters && <FormFilter name={"editor"}
                                                                          onHandleFilter={this.handleFilter}
                                                                          onHandleAllFilter={this.handleAllFilter}
                                                                          onHandleRemoveAllFilter={this.removeAllFilters}
                                                                          text={"Provider"}
                                                                          data={editor}
                                                                          meilisearch_search={meilisearch_search} />}
                        </div>
                    </div>
                    <div className="product-list">
                        { isLoading && <ProductsLoader number={6} /> }
                        {!isLoading && renderAddons}
                    </div>
                    {!isLoading && this.state.addons.length === 0 && <React.Fragment>
                        <div className="text-center mt-6 p-6">
                            <h3>{noResultsText}</h3>
                            <p className="text-muted">{noResultsSubText}</p>
                        </div>
                    </React.Fragment>}

                    {
                        page === "create" && <Fade inProp={cart_list.length === 0}>
                            <p className="my-3 text-center">{storeBtnTopText}</p>
                        </Fade>
                    }
                    <div className="d-flex m-5 justify-content-center gap-5">
                        { isLoadingMore && <div className="spinner-border text-warning" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div> }
                        { !isLoadingMore && this.state.addons.length < this.state.estimatedTotalHits &&
                            <a className="has-text-link mb-0" id="stepper-load-btn" onClick={this.handlePaginate}>{loadMoreText} <i className="bi bi-chevron-down"></i></a>}
                        { !isLoadingMore && page === "create" && <a onClick={this.storeRedirectCart} className="has-text-link mb-0" id="stepper-footer-btn">{ cart_list.length > 0 ? storeNextText : storeSkipText }</a>}
                    </div>
                </CatalogContext.Provider>
            </React.Fragment>
        );
    }
}

export default CountryProducts;
